/**
 * Created by Ram on 12/05/2017.
 */

import * as React from "react";
import { Component } from "react";
import BatteryStats from "../presentation/BatteryStats";
import dynamicSort from "../../logic/DynamicSort";
import { Device, Platform, TestInstance } from "../dec";

interface Props {
  pageParameters: any[];
  navigator: any;
}

interface State {
  testInstanceId: string;
  isDeviceSelected: {
    [key: string]: boolean;
  };
  testInstance: TestInstance;
  devices: Device[];
  displayGraphByPlatform: Platform;
  sortAsc: boolean;
  sort: string;
}

class BatteryStatsWidget extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      testInstanceId: this.props.pageParameters[0],
      isDeviceSelected: {},
      testInstance: null,
      devices: [],
      displayGraphByPlatform: Platform.BOTH,
      sortAsc: true,
      sort: "name"
    };
  }

  componentDidMount() {
    this.getSingleTestInstance();
  }

  getSingleTestInstance = () => {
    fetch(
      "/service/getSingleTestInstanceDetails?testInstanceId=" +
        this.state.testInstanceId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(testInstance => {
          this.updateUIState(testInstance)
        });
      }
    });
  };

  updateUIState(testInstance: TestInstance) {
    let isDeviceSelected = {};
    testInstance.devices.forEach((device: any) => {
      isDeviceSelected[device.deviceId] = true;
    });

    // If only one kind of device in test, set graph display filter accordingly
    let displayGraphByPlatform = Platform.BOTH;
    if (testInstance.devices.every((device: Device) => device.os === Platform.IOS)) {
      displayGraphByPlatform = Platform.IOS;
    } else if (testInstance.devices.every((device: Device) => device.os === Platform.ANDROID)) {
      displayGraphByPlatform = Platform.ANDROID;
    }

    this.setState({ testInstance: testInstance, devices: this.addBatteryDrainValues(testInstance.devices, testInstance.scenario.deviceDPH), isDeviceSelected, displayGraphByPlatform }, () => this.sortDevices());
  }

  updateSortState: (sortBy: string) => void = sortBy => {
    const callback = () => this.sortDevices();
    if (sortBy === this.state.sort) {
      this.setState((prevState: State) => ({ sortAsc: !prevState.sortAsc }), callback);
    } else {
      this.setState({ sort: sortBy }, callback);
    }
  };

  addBatteryDrainValues(devices: Device[], deviceDPH: number | null ) {
    return devices.map(device => {
      device.survivability = false;
      if (device.batteryLog) {
        const { batteryStart, batteryEnd } = device.batteryLog;

        if (batteryStart) {
          device.batteryStart = Number(
              batteryStart.batteryPercentage
          );
          device.batteryStartTime = new Date(
              batteryStart.time
          );
        }

        if (batteryEnd) {
          device.batteryEnd = Number(
              batteryEnd.batteryPercentage
          );
          device.batteryEndTime = new Date(
              batteryEnd.time
          );
          device.survivability = true;
        }

        const MILLISECONDS_IN_HOUR = 60 * 60 * 1000;

        // Drain per hour is equal to total drain divided by the number of
        // milliseconds the test ran for, all divided by the number of milliseconds in an hour.
        if (batteryStart && batteryEnd) {
          device.totalDrain = device.batteryStart - device.batteryEnd;
          device.DPH =
              (device.totalDrain /
                  (device.batteryEndTime.getTime() - device.batteryStartTime.getTime())) *
              (MILLISECONDS_IN_HOUR);

          if (!isNaN(deviceDPH)) {
            device.sdkDPH =  Math.max(device.DPH - deviceDPH, 0);
          }
        }
      }
      return device;
    })
  }

  sortDevices: () => void = () => {
    if (this.state.devices.length) {
      // Sort devices according to sort preferences
      let sort = this.state.sort;
      let sortAsc = this.state.sortAsc;
      const devicesCopy = [...this.state.devices];

      let devicesSorted = devicesCopy.sort(dynamicSort(sort, sortAsc ? 1 : -1));

      this.setState({ devices: devicesSorted });
    }
  };

  toggleIsDeviceSelected: (deviceId: any) => void = (deviceId) => {
    this.setState(prevState => {
      let { isDeviceSelected } = { ...prevState };
      isDeviceSelected[deviceId] = !isDeviceSelected[deviceId];
      return { isDeviceSelected };
    });
  };

  toggleAllDevicesSelected = () => {
    this.setState(prevState => {
      let { isDeviceSelected } = { ...prevState };

      if (
        Object.keys(prevState.isDeviceSelected).every(
          deviceId => prevState.isDeviceSelected[deviceId]
        )
      ) {
        Object.keys(isDeviceSelected).forEach(deviceId => {
          isDeviceSelected[deviceId] = false;
        });
      } else {
        Object.keys(isDeviceSelected).forEach(deviceId => {
          isDeviceSelected[deviceId] = true;
        });
      }

      return { isDeviceSelected };
    });
  };

  updateGraphByPlatform = (e: any) => {
    this.setState({
      displayGraphByPlatform: e.target.value
    });
  };

  render() {
    return (
      <BatteryStats
        loadData={this.state}
        updateSortState={this.updateSortState}
        updateGraphByPlatform={this.updateGraphByPlatform}
        toggleIsDeviceSelected={this.toggleIsDeviceSelected}
        toggleAllDevicesSelected={this.toggleAllDevicesSelected}
      />
    ); //return
  } //render
} //BatteryStatsWidget

export default BatteryStatsWidget;
